import React from "react";
import styled from "styled-components";
import { navigate } from "gatsby-plugin-intl";
import { useIntl } from "gatsby-plugin-intl";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import get from "lodash/get";
import { graphql } from "gatsby";

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.color[props.backgroundColor]};
  color: ${(props) => props.theme.color[props.textColor]};
`;

const StyledTitle = styled.div`
  flex: 1 0 5rem;
  position: relative;
  font-size: 1.8rem;
  line-height: 1.6rem;
  font-weight: bold;
  padding: 2rem 1rem 1rem 1rem;
`;

const StyledBottomLeftTextWrapper = styled.div`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  right: 1rem;
`;

const StyledModalWrapper = styled.div`
  display: flex;
`;

const StyledModal = styled.div`
  width: 50%;
  height: 80vh;
  position: relative;
  &:hover {
    cursor: pointer;
    opacity: 0.85;
  }
`;

const StyledModalTitle = styled.div`
  font-size: 1.4rem;
  line-height: 1.4rem;
  font-weight: 600;
  margin-bottom: 0.4rem;
`;

const StyledModalSubtitle = styled.div`
  font-size: 0.8rem;
`;

const TwoGridModal = ({
  title,
  imageDescriptions,
  textColor,
  backgroundColor,
}) => {
  const intl = useIntl();
  const handleClick = (link) => {
    if (link) {
      navigate(link);
    }
  };
  return (
    <StyledWrapper backgroundColor={backgroundColor} textColor={textColor}>
      <StyledTitle>{get(title, intl.locale, "")}</StyledTitle>
      <StyledModalWrapper>
        {imageDescriptions.map((imageDescription, i) => (
          <StyledModal onClick={() => handleClick(imageDescription.link)}>
            <GatsbyImage
              style={{ width: "100%", height: "100%" }}
              image={getImage(imageDescription.asset.imageFile)}
            />
            <StyledBottomLeftTextWrapper>
              <StyledModalTitle>
                {get(imageDescription, `title[${intl.locale}]`, "")}
              </StyledModalTitle>
              <StyledModalSubtitle>
                {get(imageDescription, `description[${intl.locale}]`, "")}
              </StyledModalSubtitle>
            </StyledBottomLeftTextWrapper>
          </StyledModal>
        ))}
      </StyledModalWrapper>
    </StyledWrapper>
  );
};

export default TwoGridModal;

export const query = graphql`
  fragment twoGridModal on STRAPI_ComponentBaseTwoGridModal {
    __typename
    id
    title {
      en
      es
      it
    }
    textColor {
      color
    }
    backgroundColor {
      color
    }
    imageDescriptions {
      asset {
        url
        imageFile {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
      }
      vimeoURL
      title {
        en
        es
        it
      }
      link
      description {
        en
        es
        it
      }
    }
  }
`;
